import type { GroupBase } from 'react-select';

import type { RSelectProps } from './react-select';
import { Select } from './react-select';

import { FormItem, FormMessage } from '../form';

export function FormSelect<
  Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>,
>({ formItemClassName, ...props }: RSelectProps<Option, IsMulti, Group> & { formItemClassName?: string }) {
  return (
    <FormItem className={formItemClassName}>
      <Select {...props} />
      <FormMessage title={typeof props.label === 'string' ? props.label : undefined} />
    </FormItem>
  );
}
